/**
 * Tracking eventi di gioco → API Lupo Game su vibecanyon.com. I dati si vedono nella dashboard
 * https://vibecanyon.com/admin. Vedi TRACKING_INTEGRATION.md.
 *
 * Client-side, ZERO dipendenze, NON bloccante (try/catch ovunque: non deve MAI rompere il gioco).
 * Invio con `sendBeacon` + `text/plain`: robusto (nessun preflight, e `game_end` parte anche mentre
 * la pagina si chiude). L'endpoint abilita comunque CORS (`*`) per il fallback fetch.
 *
 * TRAPPA (documentata su WAKE): l'URL DEVE essere ASSOLUTO. Il gioco gira su un sottodominio (o su
 * itch.io / gamemonetize), quindi un `/api/track` relativo finirebbe sul dominio sbagliato → 404.
 */
const TRACK_URL = 'https://vibecanyon.com/api/track';
const GAME = 'zoolympics'; // slug ufficiale di questo gioco (non cambiare)

type Meta = Record<string, unknown>;

function makeSessionId(): string {
  try {
    if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  } catch {
    /* crypto non disponibile */
  }
  return `${GAME}-${Date.now()}-${Math.floor(Math.random() * 1e6)}`;
}

const SESSION_ID = makeSessionId();

export function track(event: string, metadata?: Meta): void {
  try {
    const payload: Meta = { event, game: GAME, sessionId: SESSION_ID };
    if (metadata) payload.metadata = metadata;
    const body = JSON.stringify(payload);
    const blob = new Blob([body], { type: 'text/plain' });
    // sendBeacon: fire-and-forget, sopravvive al cambio pagina.
    if (navigator.sendBeacon && navigator.sendBeacon(TRACK_URL, blob)) return;
    // fallback non bloccante (CORS abilitato sull'endpoint).
    void fetch(TRACK_URL, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'text/plain' },
      body,
    }).catch(() => {});
  } catch {
    /* mai rompere il gioco */
  }
}

export const tracking = {
  /** Sessione avviata (gioco caricato e giocabile). Una volta al boot. */
  gameStart: (): void => track('game_start'),
  /** Uscita / chiusura pagina. */
  gameEnd: (metadata?: Meta): void => track('game_end', metadata),
  /** Una gara è iniziata: numeratore del funnel start→finish. */
  raceStart: (metadata?: Meta): void => track('race_start', metadata),
  /** Gara completata al traguardo = un punteggio (metric = tempo o distanza a seconda della gara). */
  score: (value: number, metadata?: Meta): void =>
    track('score_recorded', { score: value, ...(metadata ?? {}) }),
  /** Traguardo sbloccato (es. nuovo record del mondo). */
  achievement: (id: string, metadata?: Meta): void =>
    track('achievement_unlocked', { id, ...(metadata ?? {}) }),
};
